import './DigitalPdf.scss';
import React, { useState, useEffect } from "react";
import fnc from '../mymod/commFunction';
import fncS4 from '../mymod/commFunction4';
import HeaderTitle from '../comm/HeaderTitle';
import redux from '../reduxToolkit/redux';
import { useSelector, useDispatch } from 'react-redux';
import { setList_pdf, setRow_pdf, setRowIdx_pdf, setHeaderInfo } from '../reduxToolkit/redux';
import { Button } from '@mui/material';
  

const DigitalPdf = ({ setIsModal }) => {
    const dispatch = useDispatch();
    const imgUrl = process.env.REACT_APP_imgUrl;
    const headerInfo = useSelector(state => state.reduxStore.headerInfo);
    const list_pdf = useSelector(state => state.reduxStore.list_pdf);
    const rowIdx_pdf = useSelector(state => state.reduxStore.rowIdx_pdf);
    const selectedUnit_pdf = useSelector(state => state.reduxStore.selectedUnit_pdf);

    const [imagePath, setImagePath] = useState('');
    const [title, setTitle] = useState('');
    const [selectedListItem, setSelectedListItem] = useState({});
    const [error, setError] = useState(null);

    useEffect(() => {
        setSelectedListItem(list_pdf[rowIdx_pdf]);
    }, []);

    // useEffect(() => {
    //     if (selectedListItem) { //(acaCode=1000인듯)
    //         const newImagePath = selectedListItem.imagePath;
    //         setImagePath(newImagePath);
    //     }
    // }, [selectedListItem, headerInfo]); // 의존성 배열에 selectedListItem과 headerInfo 추가

    useEffect(() => {

        const selectedListItem = list_pdf[rowIdx_pdf];
        if (!selectedListItem) {
            setError('Selected list item not found.');
            return;
        }

        const fetchData = async () => {
            try {
                const newImagePath = await fncS4.getS3Path(selectedListItem.imagePath);
                setImagePath(newImagePath);
                
            } catch (error) {
                console.error("Error fetching image path:", error);
                setError("Failed to load image.");
            }
        };

        fetchData();
    }, [list_pdf, rowIdx_pdf]);


    function handlePre() {
        if (rowIdx_pdf == 0) {
            alert('처음입니다.');
            return;
        }

        const newRowIdx = rowIdx_pdf - 1;
        dispatch(setRowIdx_pdf(newRowIdx));

        const label =  `${selectedUnit_pdf} ${newRowIdx + 1}쪽`;
        dispatch(setHeaderInfo({title: label, direction: -1}));
    }

    function handleNext() {
        if (rowIdx_pdf == list_pdf.length - 1) {
            alert('마지막입니다.');
            return;
        }
        const newRowIdx = rowIdx_pdf + 1;
        dispatch(setRowIdx_pdf(newRowIdx));
        const label =  `${selectedUnit_pdf} ${newRowIdx + 1}쪽`;
        dispatch(setHeaderInfo({title: label, direction: -1}));
    }
    //========================================================================
    return (
        <div className='DigitalPdf'>    
            <Button className='btnClose-me' onClick={() => setIsModal(false)} >
                <i class="fa-solid fa-xmark"></i>
            </Button> 

            <HeaderTitle title={title} direction={1} onBackClick={() => setIsModal(false)} /> 
            
            <div className='box-imgPdf'>
                {error ? (
                        <div className="error-message">{error}</div>
                    ) : (
                        imagePath && <img className='imgPdf' src={imagePath} alt="PDF Page" />
                    )}
            </div>
          
            <div className='box-menu'>
                <Button className='btnPreNext h-btn-red' onClick={handlePre}>이전</Button> 
                <Button className='btnPreNext h-btn-red' onClick={handleNext}>다음</Button> 
            </div>
           
        </div>
    );
}

export default DigitalPdf;